import { render, staticRenderFns } from "./ObraContentTabs.vue?vue&type=template&id=625c56d1"
import script from "./ObraContentTabs.vue?vue&type=script&lang=js"
export * from "./ObraContentTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports